import React from 'react';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import { Button } from './styles'

const HomeContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 70vh;
`;

const Title = styled.h1`
    font-size: 2em;
    margin-bottom: 20px;
    text-align: center;
`;

const Description = styled.p`
    font-size: 1.2em;
    text-align: center;
`;


const Home = ({ onStartClick }) => {
    const navigate = useNavigate(); 

    const handleStartClick = () => {
        navigate('/irl-to-erache-converter');
    };

    return (
        <HomeContainer>
            <Title>Bienvenue sur Chronofield</Title>
            <Description>
                Chronofield est une suite d'outils liée aux calendriers utilisés sur le serveur Minefield.fr
            </Description>
            <Button onClick={handleStartClick}>Commencer</Button>
        </HomeContainer>
    );
};

export default Home;